import { useState } from "react";
import Icon from "../../components/shared/Icon";
import { useAuth } from "../../context/AuthContext";

export default function AdminLogin({ onLogin, goBack }) {
  const [email, setEmail] = useState("");
  const [pass, setPass]   = useState("");
  const [showPass, setShowPass] = useState(false);
  const { loginAdmin, loading, error, setError } = useAuth();

  const handleLogin = async () => {
    if (!email || !pass) { setError("Enter email and password."); return; }
    setError(null);
    const ok = await loginAdmin(email, pass);
    if (ok) onLogin();
  };

  return (
    <div style={{ minHeight:"100vh", display:"flex", fontFamily:"'Segoe UI',system-ui,sans-serif" }}>
      <div style={{ width:"42%", background:"linear-gradient(160deg,#0d2744 0%,#1a3a6b 50%,#0d6a4f 100%)", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:48, position:"relative", overflow:"hidden" }}>
        <div style={{ position:"relative", zIndex:1, textAlign:"center" }}>
          <div style={{ width:88, height:88, borderRadius:22, background:"linear-gradient(135deg,#42a5f5,#1565c0)", display:"flex", alignItems:"center", justifyContent:"center", margin:"0 auto 24px", boxShadow:"0 12px 40px rgba(66,165,245,0.4)" }}>
            <Icon name="building" size={44} color="#fff" />
          </div>
          <h2 style={{ color:"#fff", fontSize:26, fontWeight:800, margin:"0 0 8px" }}>Admin Portal</h2>
          <p style={{ color:"rgba(255,255,255,0.55)", fontSize:14, margin:"0 0 36px" }}>Society Management System</p>
          {[["Manage Society","Register and configure your society"],["Member Management","Add, edit, and track all members"],["Accounts & Finance","Full accounting module integrated"]].map(([t,d]) => (
            <div key={t} style={{ display:"flex", gap:10, marginBottom:16, textAlign:"left" }}>
              <div style={{ width:26, height:26, borderRadius:7, background:"rgba(66,165,245,0.2)", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0, marginTop:2 }}><Icon name="check" size={13} color="#42a5f5" /></div>
              <div><div style={{ color:"#fff", fontSize:13, fontWeight:600 }}>{t}</div><div style={{ color:"rgba(255,255,255,0.45)", fontSize:12, marginTop:2 }}>{d}</div></div>
            </div>
          ))}
        </div>
      </div>
      <div style={{ flex:1, display:"flex", alignItems:"center", justifyContent:"center", background:"#f8fafc", padding:40 }}>
        <div style={{ width:"100%", maxWidth:400 }}>
          <h2 style={{ margin:"0 0 4px", fontSize:24, fontWeight:800, color:"#1a2744" }}>Admin Login</h2>
          <p style={{ margin:"0 0 28px", fontSize:13, color:"#78909c" }}>Sign in to your society account</p>
          <div style={{ marginBottom:16 }}>
            <label style={{ display:"block", fontSize:11, fontWeight:700, color:"#546e7a", marginBottom:5, textTransform:"uppercase" }}>Email</label>
            <input value={email} onChange={e=>setEmail(e.target.value)} type="email" placeholder="admin@society.com"
              onKeyDown={e=>e.key==="Enter"&&handleLogin()}
              style={{ width:"100%", padding:"11px 12px", border:"1.5px solid #e0e0e0", borderRadius:9, fontSize:14, outline:"none", boxSizing:"border-box" }} />
          </div>
          <div style={{ marginBottom:22 }}>
            <label style={{ display:"block", fontSize:11, fontWeight:700, color:"#546e7a", marginBottom:5, textTransform:"uppercase" }}>Password</label>
            <div style={{ position:"relative" }}>
              <input type={showPass?"text":"password"} value={pass} onChange={e=>setPass(e.target.value)} placeholder="••••••••"
                onKeyDown={e=>e.key==="Enter"&&handleLogin()}
                style={{ width:"100%", padding:"11px 38px 11px 12px", border:"1.5px solid #e0e0e0", borderRadius:9, fontSize:14, outline:"none", boxSizing:"border-box" }} />
              <button onClick={()=>setShowPass(!showPass)} style={{ position:"absolute", right:11, top:"50%", transform:"translateY(-50%)", background:"none", border:"none", cursor:"pointer", color:"#90a4ae", padding:0 }}><Icon name={showPass?"eyeOff":"eye"} size={15} /></button>
            </div>
          </div>
          {error && <div style={{ background:"#fce8e6", color:"#c62828", padding:"10px 14px", borderRadius:8, fontSize:13, marginBottom:16 }}>{error}</div>}
          <button onClick={handleLogin} disabled={loading}
            style={{ width:"100%", padding:"13px", background:loading?"#ccc":"linear-gradient(135deg,#42a5f5,#1565c0)", border:"none", borderRadius:10, color:"#fff", fontSize:15, fontWeight:700, cursor:loading?"not-allowed":"pointer" }}>
            {loading ? "Signing in…" : "Sign In"}
          </button>
          <button onClick={goBack} style={{ width:"100%", padding:"11px", marginTop:12, background:"none", border:"1.5px solid #e0e0e0", borderRadius:10, color:"#546e7a", fontSize:14, cursor:"pointer" }}>← Back</button>
        </div>
      </div>
    </div>
  );
}
